__turbopack_context__.v({
  "root": "styles-module-scss-module__HBOiYa__root",
});
